import InterfaceValidator from "@/pages/admin/interface-validator/InterfaceValidator";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const InterfaceDashboardTabs = lazy(() => import("@/pages/admin/finance/InterfaceDashboard/InterfaceDashboardTabs"));
const UnpostableCommissions = lazy(() => import("@/pages/admin/finance/UnpostableCommissions/UnpostableCommissions"));
const UnclaimedCommissions = lazy(() => import("@/pages/admin/finance/UnclaimedCommissions/UnclaimedCommissions"));
const NewUnclaimedCommissions = lazy(
  () => import("@/pages/admin/finance/UnclaimedCommissions/NewUnclaimedCommissions/NewUnclaimedCommissions"),
);
const EditUnclaimedCommission = lazy(
  () => import("@/pages/admin/finance/UnclaimedCommissions/EditUnclaimedCommission/EditUnclaimedCommission"),
);
const AgentPersonalBookings = lazy(() => import("@/pages/admin/finance/AgentPersonalBookings/AgentPersonalBookings"));
const ClientDirectDeposits = lazy(() => import("@/pages/admin/finance/ClientDirectDeposits/ClientDirectDeposits"));
const UploadClientDirectDeposits = lazy(
  () => import("@/pages/admin/finance/ClientDirectDeposits/UploadClientDirectDeposits/UploadClientDirectDeposits"),
);
const EditClientDirectDeposit = lazy(
  () => import("@/pages/admin/finance/ClientDirectDeposits/EditClientDirectDeposit/EditClientDirectDeposit"),
);
const AgencyCommissions = lazy(() => import("@/pages/admin/finance/AgencyCommissions/AgencyCommissions"));
const InvoicesReconciliation = lazy(
  () => import("@/pages/admin/finance/InvoicesReconciliation/InvoicesReconciliation"),
);
const ReconciliationDashboard = lazy(
  () => import("@/pages/admin/finance/InvoicesReconciliation/Dashboard/ReconciliationDashboard"),
);
const Sales = lazy(() => import("@/pages/admin/finance/Sales/Sales"));

const financeRoutes: RouteObject[] = [
  {
    path: "invoices-qa",
    children: [
      {
        index: true,
        element: <InterfaceValidator />,
      },
      {
        path: "interface-dashboard",
        element: <InterfaceDashboardTabs />,
      },
    ],
  },
  {
    path: "unpostable-commissions",
    element: <UnpostableCommissions />,
  },
  {
    path: "unclaimed-commissions",
    children: [
      {
        index: true,
        element: <UnclaimedCommissions />,
      },
      {
        path: "new",
        element: <NewUnclaimedCommissions />,
      },
      {
        path: ":id",
        element: <EditUnclaimedCommission />,
      },
    ],
  },
  {
    path: "agent-personal-bookings",
    element: <AgentPersonalBookings />,
  },
  {
    path: "client-direct-deposits",
    children: [
      {
        index: true,
        element: <ClientDirectDeposits />,
      },
      {
        path: "new",
        element: <UploadClientDirectDeposits />,
      },
      {
        path: ":id",
        element: <EditClientDirectDeposit />,
      },
    ],
  },
  {
    path: "agency-commissions",
    element: <AgencyCommissions />,
  },
  {
    path: "invoices-reconciliation",
    children: [
      {
        index: true,
        element: <InvoicesReconciliation />,
      },
      {
        path: "dashboard",
        element: <ReconciliationDashboard />,
      },
    ],
  },
  {
    path: "sales",
    element: <Sales />,
  },
];

export default financeRoutes;
